import {
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { Folder } from 'modules/documents/hooks/useGetFolders'

const folderFilter = (source: ReturnType<typeof useDocumentsDataTable>, folders: Folder[]) => {
  return buildDocumentsDataTableFilter(source, {
    type: FilterType.Id,
    categories: [
      {
        kind: 'DocumentsFolderChoice',
        operation: 'eq',
        options: folders,
      },
    ],
    identifier: 'folder_id',
    path: 'folder',
    title: i18n.t('documents.employee.filters.folder'),
  })
}

export default folderFilter
